// extracted by mini-css-extract-plugin
export default {"ValidationTable":"ValidationTable_ValidationTable__EyYNi"};